import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControlLabel, Switch, Typography } from '@mui/material';
import silentMentorApi from '../services/silentMentorApi';

export default function SilentMentorSettingsDialog({ open, onClose }) {
  const [prefs, setPrefs] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    let mounted = true;
    (async () => {
      try {
        const res = await silentMentorApi.getPreferences();
        if (mounted) setPrefs(res?.data || { enabled: true });
      } catch (e) {
        if (mounted) setPrefs({ enabled: true });
      }
    })();
    return () => (mounted = false);
  }, [open]);

  const toggleEnabled = async () => {
    if (!prefs) return;
    setSaving(true);
    try {
      const updated = { ...prefs, enabled: !prefs.enabled };
      const res = await silentMentorApi.updatePreferences(updated);
      setPrefs(res?.data || updated);
    } catch (e) {
      // ignore
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Silent Mentor Settings</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Control subtle study nudges from Silent Mentor. Turn off to stop receiving personalized tips.
        </Typography>
        <FormControlLabel
          control={<Switch checked={prefs?.enabled ?? true} onChange={toggleEnabled} disabled={saving} />}
          label={prefs?.enabled ? 'Enabled' : 'Disabled'}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
